import Cookies from 'js-cookie';
import { mergeRecentlyViewedIds, parseRecentlyViewedIds, RECENTLY_VIEWED_COOKIE_NAME } from '@/lib/recently-viewed';

const COOKIE_MAX_AGE_DAYS = 30;

type PersistRecentlyViewedProductOptions = {
    domain?: string;
    productId: string;
    siteId: string;
};

export function persistRecentlyViewedProduct({ domain, productId, siteId }: PersistRecentlyViewedProductOptions): void {
    if (!productId) {
        return;
    }

    const cookieName = `${RECENTLY_VIEWED_COOKIE_NAME}_${siteId}`;
    let existing: string[] = [];

    try {
        const raw = Cookies.get(cookieName);
        existing = parseRecentlyViewedIds(raw ? JSON.parse(raw) : []);
    } catch {
        existing = [];
    }

    Cookies.set(cookieName, JSON.stringify(mergeRecentlyViewedIds(existing, productId)), {
        domain,
        expires: COOKIE_MAX_AGE_DAYS,
        path: '/',
        sameSite: 'lax',
        secure: window.location.protocol === 'https:',
    });
}
